// LEGAL GATE (RESPA §8 / Reg Z 1026.36(d)): the EARNED pillar is a historical
// compensation record only. Every figure is labeled with its as-of date and the
// prior-period comparison window. No forward projection, no "earn more" CTA.
export const EARNINGS_HERO_LABEL = 'comp paid YTD';

export const EARNINGS_DOLLARS_PER_K = 1000;

export const EARNINGS_AS_OF_PREFIX = 'as of';

// Funded volume is shown as a SEPARATE period total alongside comp paid — never a
// per-loan rate/margin (DEV-3636, counsel-approved disclosure posture).
export const EARNINGS_FUNDED_VOLUME_PREFIX = 'Funded volume:';

// Counsel-approved earnings disclaimer (DEV-3636), rendered as visible,
// non-collapsible text on the earnings panel.
export const EARNINGS_DISCLOSURE_TEMPLATE =
  'Historical record of compensation already paid and loans already funded during the period shown, as of the date shown. Compensation and funded volume are shown as period totals; no per-loan rate, margin, or effective rate is calculated or displayed. Not an offer, commitment, or projection, and not tied to or affected by future business decisions, loan pricing, or loan volume.';
